import * as yup from 'yup';

export const schemaClientDocument = yup.object().shape({
  client_id: yup.string().required('Cliente obrigatório'),
  professional_id: yup.string().required('Profissional obrigatório'),
  document_id: yup.string().required('Modelo de documento obrigatório'),
  text_description: yup.string().required('Campo de texto obrigatório'),
});
